import type { EmployeeDesignation } from '../types';
import type { HandbookTrainingNode } from '../types/handbookTraining';
import { hasOfficeOpsPrivileges } from './employeeDesignations';

/** May browse published training library (People handbook readers). */
export function canViewHandbookTraining(authRole: string | undefined): boolean {
  return (
    authRole === 'employee'
    || authRole === 'admin'
    || authRole === 'staff'
    || authRole === 'employee_office'
    || authRole === 'employee_shop'
  );
}

/** May create/edit training nodes (executives, office staff, EAs — not field staff). */
export function canManageHandbookTraining(args: {
  authRole: string | undefined;
  designations?: EmployeeDesignation[] | string[] | undefined;
}): boolean {
  if (args.authRole === 'admin') return true;
  if (hasOfficeOpsPrivileges(args.designations)) return true;
  return args.authRole === 'employee';
}

const SLUG_RE = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export function normalizeHandbookTrainingSlug(raw: string): string {
  return raw
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function isValidHandbookTrainingSlug(slug: string): boolean {
  return slug.length >= 2 && slug.length <= 80 && SLUG_RE.test(slug);
}

/** Published training videos the user has not opened yet. */
export function isHandbookTrainingVideoNew(
  node: HandbookTrainingNode,
  watchedNodeIds: ReadonlySet<string>,
): boolean {
  return node.kind === 'video' && node.published === true && !watchedNodeIds.has(node.id);
}
